import(/* webpackMode: "eager" */ "/app/next/app/global-error.tsx");
